import { createFileRoute } from '@tanstack/react-router'

import { PlatformReferralsPage } from '../../../components/pages/backoffice/platform/platform-referrals-page/platform-referrals-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/referrals')({
  component: () => (
    <PermissionChecker requiredPermissions={['referral.manage']}>
      <PlatformReferralsPage />
    </PermissionChecker>
  ),
})
